module.exports = __webpack_public_path__ + "img/hangman.69730a64.svg";